import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AppGlobals } from 'app/app.globals';

import { Prestation } from '../../services/agenda/prestation'

@Component({
  selector: 'modif-periode-dialog',
  templateUrl: 'modif-periode-dialog.component.html',
})
export class ModifPeriodeDialog implements OnInit {

  isAgendaHeure : boolean = true;
  isAgendaHeureDebutFin: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ModifPeriodeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
      if (this.data.code != undefined) {
        var presta = this.data.codes.filter(x => x.CodePrestationCode === this.data.code);
        if (presta.length > 0) {
          this.isAgendaHeure = (presta[0].CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE);
          this.isAgendaHeureDebutFin = (presta[0].CodePrestationEncodageHeure == AppGlobals.CLE_ENCODAGE_HEURE_DUREE);
        }
      }
    }
    onCodeChange(): void {
      var presta =this.data.codes.filter(x => x.CodePrestationCode === this.data.code)[0];
      this.isAgendaHeure = (presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE);
      this.isAgendaHeureDebutFin = (presta.CodePrestationEncodageHeure == AppGlobals.CLE_ENCODAGE_HEURE_DUREE)
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

    onOptionChange() {
      this.data.repos = true
      this.data.debut = true
      this.data.cbDuree = true
      this.data.cbPO = true
      this.data.cbCode = true
    }

}
